var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavTradeManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Zm0 16.645c-4.216 0-7.645-3.43-7.645-7.645 0-4.216 3.43-7.645 7.645-7.645 4.216 0 7.645 3.43 7.645 7.645 0 4.216-3.43 7.645-7.645 7.645Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 6.5-.39-.422L10.733 3.5l-.857.844 1.422 1.542H4.5v1.228h6.798L9.876 8.656l.857.844 2.377-2.578zM4.5 11.5l.39-.422L7.267 8.5l.857.844-1.422 1.542H13.5v1.228H6.702l1.422 1.542-.857.844-2.377-2.578z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTradeManager);
export default __webpack_public_path__ + "static/media/nav-trade-manager.cd4d28edc4b3d3ec314012089d469bc0.svg";
export { ForwardRef as ReactComponent };